import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  selectedNominatimPoi: null,
};

export const nominatimSlice = createSlice({
  name: 'nominatimSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateSelectedNominatimPoi: (state, action) => {
      state.selectedNominatimPoi = action.payload;
    },
  },
});

export const {  updateSelectedNominatimPoi } = nominatimSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectedNominatimPoiState = (state: RootState) => state.nominatimSlice.selectedNominatimPoi;
export default nominatimSlice.reducer;
